import * as React from "react";
import {Icon, SemanticICONS} from 'semantic-ui-react';

interface IProps {
    playSound: boolean
}

interface IState {
}

export class VolumeToggle extends React.Component<IProps, IState> {
    public render() {
        let iconName: SemanticICONS = this.props.playSound ? 'volume up' : 'volume off'
        return (
            <Icon name={iconName} color='grey' style={{width: '20px'}}/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/VolumeToggle.tsx